var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper pa-4"},[_c('h1',[_vm._v("添加文字")]),_vm._m(0),_c('h2',[_vm._v("代码")]),_c('p',[_vm._v("1. html文字定位到 canvas里")]),_c('p',[_vm._v("DOM + CSS")]),_c('highlightjs',{staticClass:"mt-4",attrs:{"code":`.text {
  /* 直接定位到 canvas里 */
  z-index: 9999;
  position: absolute;
  top: 80px;
  left: 45%;
  grid-column: 2;
  color: white;
}`,"language":'css'}}),_c('p',[_vm._v(" 2. 将文字绘制到画布中，并将其用作Texture（纹理）"),_c('br'),_vm._v(" 其实加载一个图片 "),_c('a',{attrs:{"href":"https://cdn.jsdelivr.net/gh/miloweimo/blogimage/text.jpg"}},[_vm._v("https://cdn.jsdelivr.net/gh/miloweimo/blogimage/text.jpg")]),_c('highlightjs',{staticClass:"mt-4",attrs:{"code":`{
  // 2. 将文字绘制到画布中，并将其用作Texture（纹理）
  // 我是文字.jpg
  const texture = new THREE.TextureLoader().load( 'https://cdn.jsdelivr.net/gh/miloweimo/blogimage/text.jpg' );
  const material = new THREE.MeshBasicMaterial( { map: texture } );
  const geometry = new THREE.PlaneGeometry( 3, 3 );
  const mesh = new THREE.Mesh( geometry, material );
  // 位置
  mesh.position.set( 2, 1.5 , -3 );
  // 双面显示
  mesh.material.side = THREE.DoubleSide;
  this.scene.add( mesh );
}`,"language":'js'}})],1),_c('p',[_vm._v(" 3. three.js自带的文字几何体"),_c('br'),_vm._v(" 参考GitHub 代码 "),_c('highlightjs',{staticClass:"mt-4",attrs:{"code":`{
  // 3. three.js自带的文字几何体
  const scene = this.scene;
  // 1. loadFont
  let font = null;
  const loader = new FontLoader();
  loader.load( 'https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function ( _font ) {
    font = _font;
    console.log( font , 'font loaded');
    // 2. 创建文字几何体
    const textGeo = new TextGeometry( 'Aa.字', {
      font: font,
      size: 0.8, // 文字大小
      height: 0.2, // 文字厚度
      // curveSegments: 6, // 曲线段数
      // bevelThickness: 0.1, // 斜角厚度
      // bevelSize: 0.08, // 斜角大小
      // bevelEnabled: true // 是否斜角
    });
    textGeo.computeBoundingBox();

    // 3. 创建文字材质
    const textMaterial = new THREE.MeshBasicMaterial( { color: '#ffdd11' } );
    const textMesh = new THREE.Mesh( textGeo, textMaterial );
    textMesh.position.set( -1, 1 , -2 );
    
    scene.add( textMesh );
  })
}`,"language":'js'}})],1),_c('h2',[_vm._v("参考")]),_vm._m(1),_vm._m(2)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative full-bleed"},[_c('canvas',{staticStyle:{"border":"1px solid","max-height":"65vh","width":"100%"},attrs:{"id":"c3"}}),_c('span',{staticClass:"text"},[_vm._v("1. html文字定位到 canvas里")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"href":"https://threejs.org/docs/index.html#manual/zh/introduction/Creating-text"}},[_vm._v("创建文字（Creating text）")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"href":"https://github.com/mrdoob/three.js/blob/master/examples/webgl_geometry_text.html"}},[_vm._v("代码webgl_geometry_text.html")])])
}]

export { render, staticRenderFns }